/*
 * @Author: louzhedong
 * @Date: 2019-12-20 10:19:16
 * @LastEditors: liuxiaoyan
 * @LastEditTime: 2025-01-07 14:50:07
 * @Description:
 */
let environment = 'rc';

if (location.host.indexOf('rc.xiaomai5') != -1) {
  environment = 'rc';
} else if (location.host.indexOf('dev.xiaomai5') != -1 || location.host.indexOf('127.0.0.1:8088') != -1 || location.host.indexOf('localhost:8088') != -1) {
  environment = 'dev';
} else if (location.pathname.indexOf('gray') != -1) {
  environment = 'gray';
} else {
  environment = 'prod';
}

window.CONFIG = {
  // 微信开发者ID
  weixinAppId: 'wx5c5a1fb71ecab7bc',
  // 默认模块
  defaultModule: 'c',
  // 金额单位  1元 == 100分
  moneyUnit: 100,
  // 时间单位 1小时 == 60分 ,修改
  timeUnit: 100,
  // 版本号
  VERSION: 'v5.0.0',
  // https://rc-api-c.xiaomai5.com/
  // https://api-c.xiaomai5.com/
  // https://dev-api-c.xiaomai5.com/
  // http://10.0.7.184:8084/ //曹远东
  // http://10.0.5.206:8084/ //庞伟超
  // http://10.0.4.44:8084/ // 黄淦州
  // http://10.0.4.44:8083/ // 黄淦州 b 端
  // http://10.0.7.157:8084/ //tianlei
  // server: 'http://10.0.7.184:7000/' //曹远东
  // server: "https://dev1-heimdall.xiaomai5.com/",
  server: "https://rc-heimdall.xiaomai5.com/",
  env: EVN || "rc",
  appId: function() {
    if (environment === 'dev') {
      return 'wx3ea60e78ddfa277e';
    } else if (environment === 'rc') {
      return 'wx5c5a1fb71ecab7bc';
    } else {
      return 'wxdd6b458500d4c224';
    }
  },

  openId: function() {
    if (window.debug) {
      if (window.env === 'dev') {
        return 'ojhgkwNkTHLdk6-MAVPrjgUI_n2M';
      } else if (window.env === 'rc') {
        return 'o_D78s03yBWEVZfLlBNiq06cnn8U';
      }
    } else {
      return 'oj-c9xJjaW_Vclkdiy9MuFVpAiuU';
    }
  },

  activity: function() {
    if (environment === 'dev') {
      return 'http://dev.xiaomai5.com/share/show?appid=';
    } else if (environment === 'rc') {
      return 'https://rc.xiaomai5.com/share/show?appid=';
    } else {
      return 'https://prod.xiaomai5.com/share/show?appid=';
    }
  },

  parentHref: {
    dev: 'https://dev.xiaomai5.com/h5/index.html',
    dev1: 'https://dev.xiaomai5.com/dev1/h5/index.html',
    pre: 'https://rc.xiaomai5.com/h5/index.html',
    rc: 'https://rc.xiaomai5.com/h5/index.html',
    gray: 'https://res.xiaomai5.com/h5/gray/index.html',
    beta: 'https://res.xiaomai5.com/h5-prod-beta/index.html',
    prod: 'https://res.xiaomai5.com/h5/index.html',
  },
  jumpHomeHref: {
    dev: 'weixin://dl/business/?t=0PDbc9evoWs',
    rc: 'weixin://dl/business/?t=0PDbc9evoWs',
    gray: 'weixin://dl/business/?t=mVLK5gPGM8s',
    prod: 'weixin://dl/business/?t=mVLK5gPGM8s',
  },
  jumpMineHref: {
    dev: 'weixin://dl/business/?t=ypxeANAdM8c',
    rc: 'weixin://dl/business/?t=ypxeANAdM8c',
    gray: 'weixin://dl/business/?t=h3URm22Mnng',
    prod: 'weixin://dl/business/?t=h3URm22Mnng',
  },
  webserverHref: {
    dev: 'https://dev-web-server.xiaomai5.com/img/poster',
    dev1: 'https://dev-web-server.xiaomai5.com/img/poster',
    rc: 'https://rc-web-server.xiaomai5.com/img/poster',
    // gray: 'https://web-server.xiaomai5.com/img/poster',
    gray: 'https://rc-web-server.xiaomai5.com/img/poster',
    prod: 'https://web-server.xiaomai5.com/img/poster',
  },
  parentHost: {
    dev: 'https://dev.xiaomai5.com/h5/',
    dev1: 'https://dev.xiaomai5.com/dev1/h5/',
    pre: 'https://rc.xiaomai5.com/h5/',
    rc: 'https://rc.xiaomai5.com/h5/',
    gray: 'https://res.xiaomai5.com/h5/gray/',
    beta: 'https://res.xiaomai5.com/h5-prod-beta/',
    prod: 'https://res.xiaomai5.com/h5/',
  },
  payHost: function() {
    if (environment === 'dev') {
      return 'http://dev.xiaomai5.com/xmpay/';
    } else if (environment === 'rc') {
      return 'https://rc.xiaomai5.com/xmpay/';
    } else if (environment == 'gray') {
      return 'https://res.xiaomai5.com/xmpay/gray/index.html';
    } else {
      return 'https://res.xiaomai5.com/xmpay/index.html';
    }
  },
  wechatHost: function() {
    if (environment === 'dev') {
      return 'https://wedev.xiaomai5.com/';
    } else if (environment === 'rc') {
      return 'https://werc.xiaomai5.com/';
    } else {
      return 'https://wechat.xiaomai5.com/';
    }
  },

  salesHost: function() {
    if (environment === 'dev') {
      return 'https://dev-heimdall.xiaomai5.com/sales/';
    } else if (environment === 'rc') {
      return 'https://rc-heimdall.xiaomai5.com/sales/';
    } else if (environment === 'gray') {
      return 'https://gray-heimdall.xiaomai5.com/sales/';
    } else {
      return 'https://heimdall.xiaomai5.com/sales/';
    }
  },
  posterImageUrl: function() {
    if (environment === 'dev') {
      return 'https://dev-web-server.xiaomai5.com/img/poster/xmPoster/index';
    } else if (environment === 'rc') {
      return 'https://rc-web-server.xiaomai5.com/img/poster/xmPoster/index';
    } else if (environment === 'gray') {
      return 'https://web-server.xiaomai5.com/img/img/poster/xmPoster/index';
    } else {
      return 'https://web-server.xiaomai5.com/img/img/poster/xmPoster/index';
    }
  },
  posterImageUrl: function() {
    if (environment === 'dev') {
      return 'https://dev-web-server.xiaomai5.com/img/poster/xmPoster/index';
    } else if (environment === 'rc') {
      return 'https://rc-web-server.xiaomai5.com/img/poster/xmPoster/index';
    } else if (environment === 'gray') {
      return 'https://web-server.xiaomai5.com/img/poster/xmPoster/index';
    } else {
      return 'https://web-server.xiaomai5.com/img/poster/xmPoster/index';
    }
  },

  InsureAppId: function() {
    if (environment === 'prod') {
      return 'wx79830c900aeb7f38';
    } else if (environment === 'rc') {
      return 'wxb1ebe296bbc43820';
    } else {
      return 'wxd1f2fa07b62000f3';
    }
  },
  SharePostHtmlHost: function() {
    switch (environment) {
      case 'dev':
        return 'https://dev.xiaomai5.com/poster-page/';
      case 'rc':
        return 'https://rc.xiaomai5.com/poster-page/';
      case 'gray':
        return 'https://res.xiaomai5.com/poster-page/gray/';
      case 'prod':
        return 'https://res.xiaomai5.com/poster-page/';
      default:
        return 'https://dev.xiaomai5.com/poster-page/';
    }
  },
  ServerMap: function() {
    if (environment === 'prod') {
      return 'https://html2png-prod.xiaomai5.com/'
    } else {
      return 'https://html2png-dev.xiaomai5.com/'
    }
  },
  // 异常服务器
  exceptionServer: 'http://www.54gouwu.com/index.php',
};



// WEBPACK FOOTER //
// ./src/core/config.js